define.alias("shared/components/shared/mavely/links/link", "calendar/components/shared/mavely/links/link");